import React from 'react'
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar'
import Loading from '../Loading'
import { AttachmentType } from '../../containers/ProfileExpertCabinetPage/types'

// Styles
import './styles.scss'

export default ({
  files,
  downloadProgressFiles,
  downloadIsProcess,
  handleDownloadAll,
  handleDownload,
}: {
  files: AttachmentType[]
  downloadProgressFiles: any[]
  downloadIsProcess: boolean
  handleDownloadAll: () => void
  handleDownload: (uuid: string, url: string, name: string) => void
}) => {
  return (
    <>
      <div className={'expert-files-block'}>
        {files.map(attachment => {
          const progress = downloadProgressFiles.find(
            file => file.file_id === attachment.uuid
          )
          const isProcess = progress && progress.percent < 100
          return (
            <div key={attachment.uuid} className={'expert-files-block__item'}>
              <span>{attachment.name}</span>
              <button
                disabled={isProcess}
                onClick={() =>
                  handleDownload(
                    attachment.uuid,
                    attachment.url,
                    attachment.name
                  )
                }
              >
                {progress && isProcess ? (
                  <div className={'expert-files-block__item-progress'}>
                    <CircularProgressbar
                      value={progress.percent}
                      text={`${progress.percent}%`}
                      styles={buildStyles({
                        pathColor: '#FFF',
                        textColor: '#000',
                        trailColor: 'rgba(232, 78, 37, 0.15)',
                        backgroundColor: '#FFF',
                        textSize: '22px',
                        pathTransitionDuration: 0.2,
                      })}
                    />
                  </div>
                ) : (
                  'Скачать'
                )}
              </button>
            </div>
          )
        })}
      </div>
      {files.length > 1 ? (
        <button
          disabled={downloadIsProcess}
          onClick={handleDownloadAll}
          className={'expert-files-block__all'}
        >
          {downloadIsProcess ? (
            <Loading style={{ margin: '5px 0 0 0' }} width={34} height={34} />
          ) : (
            'Скачать все'
          )}
        </button>
      ) : null}
    </>
  )
}
